import { useState, useEffect, useRef } from "react";
import Modal from "../../../components/general/Modal";

import {
  Body,
  ButtonSpace,
  Container,
  Description,
  Footer,
  LeftBody,
  Link,
  NewAttachments,
  RightBody,
  RightFooter,
  RightHeader,
  RightContent,
  SubTitles,
  TaskDateH,
  TaskHeader,
  TaskHeaderLeft,
  TaskNameH,
  TaskStatusH,
  TaskWorker,
  WorkerIcon,
  WorkerID,
  InputDiv,
  LeftScroll,
  TaskDescription,
  LeftContent,
  Options,
  DescriptionText,
  LabelInput,
  LabelIconsContainer,
} from "./styles";

import Subtasks from "./Subtasks";
import MessageRender from "./MessageRender";
import MessageInput from "./MessageRender/MessageInput";

import { useSelector, useDispatch } from "react-redux";
import useScrollToBottom from "../../../hooks/useScrollToButton";
import { getTask } from "../../../state/activedTasks/selectors";
import Button from "../../../components/general/Button";

import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { ConfirmActivedTaskModal } from "./ConfirmActivedTaskModal";
import { toastAlert } from "../../../components/Toastify/index";
import {
  handleConfirm,
  handleAddSubtask,
  handleUpdateSubtask,
  handleRemoveSubtask,
  handleUpdateDescription,
  handleUpdateTaskLabelAT,
  handleUpdateDeadlinePagination,
} from "../../../state/activedTasks/actions";
import { handleNewMessage } from "../../../state/chat/actions";

import Upload from "../../../components/UploadFile";
import Attachment from "./Attachments/index";

import { useFileAPI } from "../../../hooks/useFileAPI";
import { getFileLog } from "../../../state/files/slice";
import {
  Close,
  ArrowRightMTask,
  ConfirmSubtask,
  EditIcon,
  TaskSquare,
  Flag,
} from "./assets";

import { getChatLog } from "../../../state/chat/selector";
import {
  updateChatLen,
  updateFilesLen,
} from "../../../state/activedTasks/actions";
import { handleListTaskAccountable } from "../../../state/users/actions";
import {
  handleUpdateAccountable,
  handleRemoveAccountable,
} from "../../../state/activedTasks/actions";
import { useHistory } from "react-router";
import { ProtectedComponent } from "../../../components/general/Protected/index";
import Accountable from "../../../components/general/Accountable/index";
import { DateTime } from "luxon";
import { DatePickerWrapper } from "../../../components/DatePickerInput";

const ConfirmTaskButton = ({ status, onClose, confirm, setState }) =>
  status === "doing" ? (
    <ButtonSpace>
      <Button
        content={<span style={{ fontSize: "13.5px" }}>Voltar</span>}
        outline
        width={"7.95rem"}
        onClick={onClose}
      />
      <Button
        greenBase
        disabled={confirm}
        content={<span style={{ fontSize: "13.5px" }}>Concluir Tarefa</span>}
        width={"11.75rem"}
        onClick={() => setState(true)}
      />
    </ButtonSpace>
  ) : null;

const getMomentDate = (task) => {
  return task.status === "doing"
    ? DateTime.fromMillis(task.moment.deadline)
    : task.status === "done"
    ? DateTime.fromMillis(task.moment.finishedAt)
    : null;
};
const DatePickerComponent = ({ refPicker, task, state, callback }) => {
  const momentDate = getMomentDate(task);
  const momentSt = task?.moment;
  const user = useSelector((state) => state.auth.user);

  const dispatch = useDispatch();

  const currentStatus =
    task.status === "doing" ? momentSt.currentStatus : task.status;

  const deadline =
    task.status === "doing" || task.status === "done"
      ? momentDate.setLocale("pt-BR").toFormat("dd MMM yyyy")
      : "--";

  const statusPermission = task.status === "doing";
  const rankPermission = user.rank === "admin" || user.rank === "gerente";

  async function handleConfirmDatePicker(delayTime, callback) {
    const delayInMillis = delayTime.getTime();

    let opcoesDate = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    let formatedDate = delayTime.toLocaleDateString("pt-BR", opcoesDate);

    dispatch(
      handleUpdateDeadlinePagination({
        taskId: task._id,
        delayTime: delayInMillis,
      })
    )
      .then(() => {
        toastAlert({
          msg: `A tarefa ${task.label} teve o prazo atualizado para ${formatedDate}`,
        });
        callback();
      })
      .catch(() => {
        toastAlert({
          isError: true,
          msg: `Ocorreu um erro ao atualizar a data da tarefa`,
        });
        callback();
      });
  }
  return (
    <>
      {statusPermission && rankPermission ? (
        <DatePickerWrapper
          refPicker={refPicker}
          state={state}
          date={momentDate}
          onConfirm={(data) => handleConfirmDatePicker(data, callback)}
        >
          <TaskDateH status={currentStatus}>
            <Flag />
            {deadline}
          </TaskDateH>
        </DatePickerWrapper>
      ) : (
        <TaskDateH status={currentStatus}>
          <Flag />
          {deadline}
        </TaskDateH>
      )}
    </>
  );
};

const getDelayDate = (task) => {
  const moment = task.moment;

  if (!moment) return false;

  const status = moment.currentStatus;

  if (status === "doing") {
    const DayinMillis = 24 * 60 * 60 * 1000;
    const date = new Date(task.moment.deadline + DayinMillis);
    return date;
  } else if (status === "late") {
    const date = new Date();
    date.setDate(date.getDate() + 1);

    return date;
  } else {
    return false;
  }
};

const TasksModal = ({ current = {}, isOpen, onClose, type }) => {
  const [comment, setComment] = useState({ msg: "", isOpen: false });
  const [listAccountables, setListAccountables] = useState([]);
  const task = useSelector((state) => getTask(state, current._id));

  const [delayTask, setDelayTask] = useState(getDelayDate(task));
  const refPicker = useRef();
  const dispatch = useDispatch();

  const fileLog = useSelector((state) => state.fileLog);
  const taskFileLog = getFileLog(fileLog, task._id);

  const chatLog = useSelector((state) => getChatLog(state, task._id));

  const user = useSelector((state) => state.auth.user);

  const accountable = task.accountable;

  const handles = {
    updateAcc: handleUpdateAccountable,
    removeAcc: handleRemoveAccountable,
  };

  const [label, setLabel] = useState({ title: task.label, isOpen: false });
  const status = task.status;
  const description = task.description;
  const [currentSubtask, setCurrentSubtask] = useState({
    id: "",
    title: "",
    checked: false,
  });

  const [confirmActivedTask, setConfirmActivedTask] = useState(false);
  const [typeFilter, setTypeFilter] = type;

  const { promiseInProgress: chatLoading } = usePromiseTracker({
    area: "fetching-chat",
  });

  const { promiseInProgress: chatSending } = usePromiseTracker({
    area: "chat",
  });

  const [taskDescription, setTaskDescription] = useState({
    textarea: description,
    isOpen: false,
  });
  const subtasks = task.subtasks;
  const momentSt = task.moment;
  const openDescription = () =>
    setTaskDescription({ ...taskDescription, isOpen: true });

  const closeDescription = () =>
    setTaskDescription({ ...taskDescription, isOpen: false });

  const allSubtasksDone = () =>
    subtasks.find((item) => !item.checked) ? true : false;

  const confirmDisable = () => {
    return task.status === "doing" && allSubtasksDone() ? true : false;
  };
  const confirm = confirmDisable();

  const elementRef = useScrollToBottom(chatLoading);

  const scrollToBottom = (e) => {
    const el = e.current;
    el.scrollTop = el.scrollHeight - el.clientHeight;
  };

  const currentStatus = status === "doing" ? momentSt.currentStatus : status;

  const history = useHistory();

  const statusText =
    currentStatus === "doing"
      ? "Em execução"
      : status === "pending"
      ? "Pendente"
      : status === "done"
      ? "Concluído"
      : "Atrasado";

  async function addSubtask() {
    await trackPromise(
      dispatch(handleAddSubtask({ taskId: task._id })),
      "subtasks"
    );
  }

  async function updateSubtask({ title, checked, id }) {
    const response = await trackPromise(
      dispatch(
        handleUpdateSubtask({
          flowTitle: task.projectName,
          taskId: task._id,
          id,
          title,
          checked,
        })
      ),
      "subtasks"
    );
    return response;
  }

  async function deleteSubtask({ id }) {
    const response = await trackPromise(
      dispatch(handleRemoveSubtask({ taskId: task._id, id })),
      "subtasks"
    );
    return response;
  }

  async function fetchAccountables() {
    try {
      const res = await dispatch(handleListTaskAccountable());
      setListAccountables(res.data.usersByTenant);
    } catch (err) {
      toastAlert({
        msg: `Ocorreu um erro ao buscar usuários disponiveis: ${err}`,
        isError: true,
      });
    }
  }

  async function updateDescription() {
    const response = await trackPromise(
      dispatch(
        handleUpdateDescription({
          taskId: task._id,
          description: taskDescription.textarea,
        })
      ),
      "description"
    );
    return response;
  }
  const confirmDescription = () => {
    updateDescription().then((res) => {
      closeDescription();
    });
  };

  async function confirmTask() {
    await trackPromise(
      dispatch(
        handleConfirm({
          flowId: task.flowId,
          taskId: task._id,
        })
      ).then((res) => {
        toastAlert({ msg: `'${task.label}' Concluída com sucesso!` });
        setTypeFilter({ ...typeFilter, status: "doing" });
        setConfirmActivedTask(false);
        onClose();
      }),
      "activate-task"
    );
  }

  const sanitizeMessage = (msg) => {
    const withoutTags = msg.replace(/<[^>]*>?/gm, "");
    const cleaned = withoutTags.replace(/\n{3,}/g, "\n\n").trim();
    return cleaned;
  };
  const isMessageValid = (msg) => msg.replace(/[\s\n\r]/g, "").length > 0;

  async function newMessage(msg) {
    if (!isMessageValid(msg) || chatSending) {
      return;
    }

    await trackPromise(
      dispatch(
        handleNewMessage({
          userId: user._id,
          ref: { flowId: task.flowId, taskId: task._id },
          username: user.username,
          message: sanitizeMessage(msg),
          type: "task",
        })
      ).then((res) => {
        setComment({ ...comment, msg: "" });
        scrollToBottom(elementRef);
        const payload = {
          chatLen: chatLog.length + 1,
          taskId: task._id,
        };

        dispatch(updateChatLen(payload));
      }),
      "chat"
    );
  }

  const updateFileLength = (type = "add") => {
    if (taskFileLog) {
      const len = taskFileLog.files.length;
      const payload = {
        taskId: task._id,
        fileLen: type === "add" ? len + 1 : type === "remove" ? len - 1 : len,
      };

      dispatch(updateFilesLen(payload));
    }
  };

  const verifyAccoutable = () => {
    const isColaborator = user?.rank === "colaborador";
    const isAccountable = task?.accountable?.userId === user?._id;
    if (isColaborator && !isAccountable) return false;

    return true;
  };

  const { handleUpload, handleDelete, files, fetchFiles } =
    useFileAPI(updateFileLength);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      fetchFiles(task._id);
      fetchAccountables();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const gotoFlowViewer = () => {
    history.push({
      pathname: "/workflow/",
      state: "active",
      search:
        "?" +
        new URLSearchParams({
          flowId: task.flowId,
        }).toString(),
    });
  };

  function handleOpenLabelInput() {
    setLabel({ ...label, isOpen: true });
  }

  function handleUpdateLabel() {
    if (label.title.length > 40) {
      toastAlert({
        msg: "Tamanho máximo de 40 caractéres para RÓTULO de tarefa!!",
        isError: true,
      });
      return;
    }

    if (label.title === "" || label.title === task.label) {
      return;
    }
    dispatch(handleUpdateTaskLabelAT({ label: label.title, taskId: task._id }))
      .then((res) => {
        setLabel({ ...label, isOpen: false });
      })
      .catch((err) => {
        toastAlert({
          isError: true,
          msg: `Ocorreu um erro ao trocar o título da TAREFA: ${err}`,
        });
        setLabel({ ...label, isOpen: false });
      });
  }

  function handleCancelLabel() {
    setLabel({ title: task.label, isOpen: false });
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Container>
        <Body>
          <LeftBody>
            <LeftContent>
              <TaskHeader>
                <TaskHeaderLeft>
                  <TaskSquare />
                  {!label.isOpen ? (
                    <TaskNameH onClick={handleOpenLabelInput}>
                      {label.title}
                    </TaskNameH>
                  ) : (
                    <>
                      <LabelInput
                        type="text"
                        maxLength={40}
                        onChange={(e) =>
                          setLabel({ ...label, title: e.target.value })
                        }
                        value={label.title}
                      />
                      <LabelIconsContainer>
                        <ConfirmSubtask
                          height="1.2rem"
                          className="confirm"
                          onClick={handleUpdateLabel}
                        />
                        <Close
                          className="cancel"
                          onClick={handleCancelLabel}
                          height={"0.8rem"}
                        />
                      </LabelIconsContainer>
                    </>
                  )}

                  <TaskStatusH status={currentStatus}>{statusText}</TaskStatusH>
                </TaskHeaderLeft>
                <DatePickerComponent
                  refPicker={refPicker}
                  state={[delayTask, setDelayTask]}
                  task={task}
                  callback={() => {
                    setTypeFilter({ ...typeFilter, status: "doing" });
                    onClose();
                  }}
                />
              </TaskHeader>
              <LeftScroll>
                {/* <span style={{ userSelect: 'text' }}>_id: {task._id}</span> */}
                <SubTitles>Descrição</SubTitles>

                <Description description={!!description}>
                  {description && !taskDescription.isOpen ? (
                    <DescriptionText>
                      <p>{description}</p>
                      {status !== "done" ? (
                        <EditIcon onClick={openDescription} />
                      ) : null}
                    </DescriptionText>
                  ) : !description &&
                    !taskDescription.isOpen &&
                    status !== "done" ? (
                    <span onClick={openDescription}>
                      Clique aqui para adicionar uma descrição..
                    </span>
                  ) : taskDescription.isOpen ? (
                    <TaskDescription>
                      <textarea
                        maxLength={200}
                        name="TaskDescriptionArea"
                        type="text"
                        id="CommentsOrAdditionalInformation"
                        value={taskDescription.textarea}
                        onChange={(e) =>
                          setTaskDescription({
                            ...taskDescription,
                            textarea: e.target.value,
                          })
                        }
                      ></textarea>
                      <Options>
                        <ConfirmSubtask
                          className="confirm"
                          onClick={
                            taskDescription.textarea
                              ? () => confirmDescription()
                              : null
                          }
                        />
                        <Close
                          className="cancel"
                          onClick={closeDescription}
                          height={"0.8rem"}
                        />
                      </Options>
                    </TaskDescription>
                  ) : (
                    "Sem descrição"
                  )}
                </Description>
                <ProtectedComponent
                  allowed={["admin", "gerente"]}
                  rank={user.rank}
                  callback={() => status !== "done"}
                >
                  <Accountable
                    style={{ marginTop: "2rem" }}
                    accountable={accountable}
                    list={listAccountables}
                    id={task._id}
                    status={task.status}
                    handles={handles}
                  />
                </ProtectedComponent>

                {(user.rank === "colaborador" || status === "done") &&
                accountable ? (
                  <>
                    <SubTitles>Responsável</SubTitles>
                    <TaskWorker>
                      <WorkerIcon src={accountable.avatarURL} />
                      <WorkerID>{accountable.username}</WorkerID>
                    </TaskWorker>
                  </>
                ) : !accountable && status === "done" ? (
                  <>
                    <SubTitles>Responsável</SubTitles>
                    <div>Nenhum</div>
                  </>
                ) : null}

                <Subtasks
                  addSubtask={addSubtask}
                  deleteSubtask={deleteSubtask}
                  updateSubtask={updateSubtask}
                  subtasks={subtasks}
                  current={currentSubtask}
                  setCurrent={setCurrentSubtask}
                  status={status}
                />

                <NewAttachments>
                  {status !== "done" ? (
                    <Upload
                      onUpload={handleUpload}
                      id={task._id}
                      tenantId={task.tenantId}
                      type="task"
                    />
                  ) : null}

                  {files.map((item) => (
                    <Attachment
                      key={Math.random()}
                      id={item._id}
                      AnexName={item.name}
                      AnexSize={item.readableSize}
                      DownloadLink={item.url}
                      DeleteAttachment={() =>
                        handleDelete({ fileId: item._id, taskId: task._id })
                      }
                    />
                  ))}
                </NewAttachments>
              </LeftScroll>
            </LeftContent>
          </LeftBody>
          <RightBody>
            <RightHeader>Comentários</RightHeader>
            <RightContent ref={elementRef}>
              <MessageRender task={task} user={user} />
            </RightContent>
            <RightFooter>
              {status !== "done" ? (
                <InputDiv>
                  <MessageInput
                    chatRef={elementRef}
                    newMessage={newMessage}
                    users={listAccountables}
                    subtasks={subtasks}
                    value={comment.msg}
                    setValue={(e) => setComment({ ...comment, msg: e })}
                    placeholder="Digite um comentário..."
                  />
                </InputDiv>
              ) : null}
            </RightFooter>
          </RightBody>
        </Body>
        <Footer>
          <Link onClick={gotoFlowViewer}>
            Ver fluxo completo <ArrowRightMTask />
          </Link>
          <ProtectedComponent callback={verifyAccoutable}>
            <ConfirmTaskButton
              status={status}
              onClose={onClose}
              confirm={confirm}
              setState={setConfirmActivedTask}
            />
          </ProtectedComponent>
        </Footer>
      </Container>
      <ConfirmActivedTaskModal
        name={task.label}
        onConfirm={confirmTask}
        isOpen={confirmActivedTask}
        onClose={() => setConfirmActivedTask(false)}
      />
    </Modal>
  );
};

export default TasksModal;
